// Token-based auth fallback for Safari iOS where third-party / cross-origin
// cookies (samesite=lax) get blocked.
//
// On /secret-access success we save the JWT to localStorage; this file
// monkey-patches window.fetch so every request to the backend automatically
// carries `Authorization: Bearer <token>` in addition to the cookies that
// the browser may or may not send.
//
// Same-origin deployments keep working via cookies; cross-origin Safari
// deployments now also work via the bearer header.

const STORAGE_KEY = 'gate33_admin_token';

export const saveAuthToken = (token) => {
  try {
    if (token) localStorage.setItem(STORAGE_KEY, token);
    else localStorage.removeItem(STORAGE_KEY);
  } catch { /* private mode */ }
};

export const getAuthToken = () => {
  try { return localStorage.getItem(STORAGE_KEY) || ''; } catch { return ''; }
};

export const clearAuthToken = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* */ }
};

const API = process.env.REACT_APP_BACKEND_URL || '';

export const installFetchInterceptor = () => {
  if (typeof window === 'undefined' || window.__gate33FetchPatched) return;
  const original = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isApi = url.includes('/api/') && (!API || url.startsWith(API) || url.startsWith('/api/'));
      const token = getAuthToken();
      if (isApi && token) {
        const headers = new Headers((init && init.headers) || (typeof input !== 'string' ? input.headers : undefined) || {});
        if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
        return original(input, { ...init, headers, credentials: init.credentials || 'include' });
      }
    } catch { /* fall through to original */ }
    return original(input, init);
  };

  // Also patch XMLHttpRequest used by AuthContext fallback
  const origOpen = window.XMLHttpRequest.prototype.open;
  const origSend = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.open = function patchedOpen(method, url, ...rest) {
    this.__gate33Url = url;
    return origOpen.call(this, method, url, ...rest);
  };
  window.XMLHttpRequest.prototype.send = function patchedSend(body) {
    try {
      const url = this.__gate33Url || '';
      if (typeof url === 'string' && url.includes('/api/')) {
        const token = getAuthToken();
        if (token) this.setRequestHeader('Authorization', `Bearer ${token}`);
      }
    } catch { /* */ }
    return origSend.call(this, body);
  };

  window.__gate33FetchPatched = true;
};
